import { toArray } from './core.print-ast.js';

function findInAST(root, predicate) {
  for (const node of toArray(root)) {
    if (!node) {
      continue;
    }
    if (predicate(node)) {
      return node;
    }
    if (!node || !("children" in node)) {
      continue;
    }
    const children = Array.isArray(node.children) ? node.children : [node.children];
    const match = findInAST(children, predicate);
    if (match) {
      return match;
    }
  }
}

export { findInAST };
//# sourceMappingURL=util.find-in-ast.js.map
